import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { creditNoteCounterDefaultValues, CreditNoteFormValues } from '../../constants';
import { convertUseForFormValueToApplicableBillType } from '../../utils';
import { CreditNoteCounterDialog, CreditNoteCounterDialogProps } from './CreditNoteCounterDialog';

export const CreateCreditNoteCounterDialog = ({
    active,
    handleClose,
}: Omit<CreditNoteCounterDialogProps, 'isEditForm' | 'defaultValues' | 'onSubmit' | 'isDefault'>) => {
    const { mutateAsync } = useRepositoryMutation('creditNoteBillCounters', 'add', {
        invalidateQueries: { counters: ['getAll'] },
    });

    const onSubmit = async (values: CreditNoteFormValues) => {
        const { startValue, displayCID, useFor, ...rest } = values;

        await mutateAsync({
            ...rest,
            value: parseInt(String(startValue), 10),
            displayCid: displayCID,
            applicableBillType: convertUseForFormValueToApplicableBillType(useFor),
        });

        showSuccessAlert({ description: lt('CreateCounterSuccessMessage') });
        handleClose();
    };

    return (
        <CreditNoteCounterDialog
            defaultValues={creditNoteCounterDefaultValues}
            isEditForm={false}
            active={active}
            onSubmit={onSubmit}
            handleClose={handleClose}
        />
    );
};
